/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from "react";
import Icon from "../Icon";
import styles from "./dropDownList.module.scss";
import onClickOutside from "react-onclickoutside";
import CheckBox from "../CheckBox";

class DropDownMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClickOutside = (evt) => {
    this.props.handleClickOutside(evt);
  };

  renderDropdownMenu = () => {
    let {
      options,
      triggerType,
      multipleSelect,
      state,
      id,
      menuWidth,
      isCheckboxEnabled,
      addTopMargin
    } = this.props;
    if (triggerType === "checkbox") {
      const defaultOptions = [
        { value: "all", display: "All" },
        { value: "none", display: "None" },
      ];

      options = [...defaultOptions, ...options];
    }
    return (
      <div
        id={`ls-dropdown-menu-${id}`}
        className={`${styles.menu} ${state.menuPosition} ${state.menuPositionX} ${styles.marginTop}`}
        style={{ width: menuWidth, '--marginTop': `${addTopMargin}px` }}
        role="combobox"
      >
        {state.dropdownOpen ? (
          <div role="listbox" tabIndex="-1">
            <ul
              style={{ cursor: "default" }}
              id={`optionList-${id}`}
              role="list"
              aria-expanded={state.dropdownOpen}
            >
              {options.map((option, index) => (
                <React.Fragment key={option.value}>
                  {multipleSelect ? (
                    <li
                      key={option.value}
                      data-value={option.value}
                      className={`${
                        option.isDisabled && styles.dropdown_noHover
                      }`}
                      aria-label={
                        typeof option.display === "string"
                          ? option.display
                          : option.ariaLabel
                      }
                      role="list-item"
                      aria-checked={
                        state.selectedMultipleValues.includes(index)
                      }
                    >
                      <span className={styles.menu_option}>
                        <CheckBox
                          checked={state.selectedMultipleValues.includes(index)}
                          disabled={option.isDisabled}
                          groupName={`ls-group-${id}`}
                          id={`ls-option-${id}-${index}`}
                          value={option.value}
                          onCheckboxChange={(val) =>
                            this.props.onCheckboxChange(val, index)
                          }
                        >
                          {option.display}
                        </CheckBox>
                      </span>
                    </li>
                  ) : (
                    <li
                      key={option.value}
                      data-value={option.value}
                      onClick={this.props.onOptionSelect}
                      className={`${
                        option.isDisabled && styles.dropdown_noHover
                      }`}
                      aria-label={
                        typeof option.display === "string"
                          ? option.display
                          : option.ariaLabel
                      }
                      role="list-item"
                      aria-checked={
                        state.selectedOption &&
                        state.selectedOption.toString() ===
                          option.value.toString()
                      }
                    >
                      <button
                        id={`ls-option-${id}-${option.value}`}
                        className={styles.menu_option}
                        aria-disabled={option.isDisabled}
                      >
                        <Icon
                          name={`correct-${option.value}`}
                          isHidden={true}
                          fileName="correct-18"
                          className={
                            state.selectedOption &&
                            state.selectedOption.toString() ===
                              option.value.toString() &&
                            isCheckboxEnabled
                              ? styles.selected
                              : styles.not_selected
                          }
                        />
                        <span>{option.display}</span>
                      </button>
                    </li>
                  )}
                  {option.seperator && (
                    <div
                      className={
                        triggerType === "box"
                          ? styles.dropdown_seperator_large
                          : styles.dropdown_seperator_small
                      }
                    />
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    return <>{this.renderDropdownMenu()}</>;
  }
}

export default onClickOutside(DropDownMenu);
